import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { setScreenings as setScreeningsAction } from '../../actions/SiteActions';
import { loadScreenings } from '../../lib/request';

// import * as AppPropTypes from '../../lib/PropTypes';
import PageMeta from '../partials/PageMeta';
import PageHeading from '../partials/PageHeading';
import News from '../partials/News';

import styles from '../../../styles/pages/screenings.scss';

const messages = defineMessages({
    metaTitle: {
        id: 'meta.title',
        defaultMessage: 'Title',
    },
    screeningsTitle: {
        id: 'content.sections_title.screenings_news',
        defaultMessage: 'Screenings & News',
    },
});

const propTypes = {
    setScreenings: PropTypes.func.isRequired,
    news: PropTypes.array, // eslint-disable-line
};

const defaultProps = {
    news: [
        {
            title: 'Jacob Burns Film Centre',
            subtitle: 'Focus on Nature Documentary Series',
            text:
                '<p><strong>June 20, 2019<br />7:15pm</strong></p><p>Jacob Burns Film Center<br />364 Manville Road<br />Pleasantville, NY 10570<br />USA</p><p>Tamara Dawit will be on hand for a Q & A</p><p>Focus on Nature Documentary Series</p>',
            link: {
                text: 'Learn More',
                url: 'film',
            },
        },
        {
            title: 'Example of a title',
            subtitle: '',
            text:
                '<p>Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines.</p>',
            link: {
                text: 'Learn More',
                url: 'film',
            },
        },
        {
            title: 'Example of a title',
            subtitle: '',
            text:
                '<p>Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines.</p>',
            link: {
                text: 'Learn More',
                url: 'film',
            },
        },
        {
            title: 'Example of a title',
            subtitle: '',
            text:
                '<p>Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines. Random very long text that makes up a paragraph of a few lines.</p>',
            link: {
                text: 'Learn More',
                url: 'film',
            },
        },
    ],
};

const Screenings = ({ setScreenings, news }) => {
    useEffect(() => {
        loadScreenings().then((screenings) => {
            setScreenings(screenings);
        });
    }, []);

    return (
        <div className={styles.container}>
            <PageMeta title={messages.metaTitle} />
            <PageHeading
                title={messages.screeningsTitle}
                className={styles.pageHeading}
            />
            <News items={news} className={styles.news} />
        </div>
    );
};

Screenings.propTypes = propTypes;
Screenings.defaultProps = defaultProps;

const WithStateContainer = connect(
    ({ site: { screenings } }) => ({
        news: screenings,
    }),
    dispatch => ({
        setScreenings: screenings => dispatch(setScreeningsAction(screenings)),
    }),
)(Screenings);

export default WithStateContainer;
